/* Horror Stories landing page (Oct 2026). Used by sections/hs-landing-top.liquid and hs-landing-bottom.liquid.
   1. Story videos: the video file is only fetched when someone presses play.
   2. Stickers jiggle while the page is scrolling (not for people who ask for reduced motion).
   3. On-page menu pins to the top of the screen once you scroll past it.
   4. Guide and competition forms send to Klaviyo. Marketing consent is only sent when the box is ticked.
      Ticked sign-ups are tagged "First Periods" so the Welcome Flow sends its first-periods emails.
      The competition form switches itself off after its closing time. */
(function () {
  if (window.__hsLoaded) return;
  window.__hsLoaded = true;

  var REVISION = '2024-10-15';
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* 1. Videos */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.hs-video__play');
    if (!btn) return;
    var frame = btn.closest('.hs-video__frame');
    var tpl = frame && frame.querySelector('.hs-video__tpl');
    if (!tpl || frame.classList.contains('is-playing')) return;
    var source = tpl.content.querySelector('video');
    if (!source) return;
    document.querySelectorAll('.hs-video__frame.is-playing video').forEach(function (v) { v.pause(); });
    var video = source.cloneNode(true);
    frame.appendChild(video);
    frame.classList.add('is-playing');
    var p = video.play();
    if (p && p.catch) p.catch(function () {});
    video.focus();
  });

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    /* 2. Sticker jiggle on scroll */
    var stickers = document.querySelectorAll('.hs-stickers');
    if (stickers.length && !reduceMotion) {
      var stopTimer;
      var jiggle = function (ms) {
        stickers.forEach(function (el) { el.classList.add('is-jiggling'); });
        clearTimeout(stopTimer);
        stopTimer = setTimeout(function () {
          stickers.forEach(function (el) { el.classList.remove('is-jiggling'); });
        }, ms);
      };
      jiggle(1800);
      window.addEventListener('scroll', function () { jiggle(500); }, { passive: true });
    }

    /* 3. Pin the on-page menu */
    var holder = document.querySelector('[data-hs-nav-holder]');
    var nav = holder && holder.querySelector('[data-hs-nav]');
    if (nav && 'IntersectionObserver' in window) {
      var sentinel = document.createElement('div');
      holder.parentNode.insertBefore(sentinel, holder);
      new IntersectionObserver(function (entries) {
        var past = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        holder.style.height = past ? nav.offsetHeight + 'px' : '';
        nav.classList.toggle('is-fixed', past);
      }).observe(sentinel);
    }

    /* 4. Forms */
    var config = document.querySelector('[data-hs-klaviyo-key]');
    var key = config ? config.getAttribute('data-hs-klaviyo-key') : '';
    var listId = config ? config.getAttribute('data-hs-klaviyo-list') : '';

    function send(path, body) {
      return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(key), {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', accept: 'application/vnd.api+json', revision: REVISION },
        body: JSON.stringify({ data: body })
      }).then(function (r) {
        if (!r.ok) throw new Error('Klaviyo ' + r.status);
      });
    }

    function profile(attrs) {
      return { data: { type: 'profile', attributes: attrs } };
    }

    document.querySelectorAll('form[data-hs-form]').forEach(function (form) {
      var msg = form.querySelector('.hs-form__msg');
      var button = form.querySelector('button[type="submit"]');
      // Competition: switch the form off after the closing time set in the theme editor.
      var closeAt = Date.parse(form.getAttribute('data-hs-closes') || '');
      var isClosed = function () { return !isNaN(closeAt) && Date.now() > closeAt; };
      var closeForm = function () {
        form.classList.remove('is-error');
        form.classList.add('is-done', 'is-closed');
        msg.textContent = form.getAttribute('data-hs-closed-msg') || 'This competition has now closed.';
      };
      if (isClosed()) closeForm();

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (isClosed()) { closeForm(); return; }
        form.classList.remove('is-error');
        msg.textContent = '';

        var bad = null;
        form.querySelectorAll('input[required]').forEach(function (input) {
          var ok = input.value.trim() !== '' && (input.type !== 'email' || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(input.value.trim()));
          input.setAttribute('aria-invalid', ok ? 'false' : 'true');
          if (!ok && !bad) bad = input;
        });
        if (bad) {
          form.classList.add('is-error');
          msg.textContent = bad.type === 'email' ? 'Please check your email address.' : 'Please fill in your first name.';
          bad.focus();
          return;
        }

        var done = function () {
          form.classList.add('is-done');
          msg.textContent = msg.getAttribute('data-hs-ok');
        };

        // Bots fill the hidden field. Pretend it worked and send nothing.
        var trap = form.querySelector('input[name="website"]');
        if (trap && trap.value) { done(); return; }

        if (!key) {
          form.classList.add('is-error');
          msg.textContent = 'Sign-up is not switched on yet. Please try again later.';
          return;
        }

        var email = form.querySelector('input[name="email"]').value.trim();
        var nameInput = form.querySelector('input[name="first_name"]');
        var forInput = form.querySelector('input[name="entering_for"]:checked');
        var optin = form.querySelector('input[name="optin"]');
        var kind = form.getAttribute('data-hs-form');

        var eventName = form.getAttribute('data-hs-event') ||
          (config && config.getAttribute('data-hs-comp-event')) || 'Entered Horror Stories Competition';
        var optedIn = !!(optin && optin.checked);
        var attrs = { email: email };
        if (nameInput) attrs.first_name = nameInput.value.trim();
        // The Welcome Flow splits on this profile property. Set it before the list sign-up so opt-ins get the first-periods branch.
        if (optedIn) attrs.properties = { 'Which product are you most interested in?': 'First Periods' };

        var props = { source: 'Horror Stories landing page', page: window.location.pathname };
        if (kind === 'guide') props.guide = 'WUKA Starter Guide to Periods';
        if (forInput) props.entering_for = forInput.value;
        props.marketing_opt_in = optedIn;

        // Event first (it sets the profile details), then the list sign-up for people who ticked the box.
        var subscribe = function () {
          if (!optedIn || !listId) return;
          return send('subscriptions', {
            type: 'subscription',
            attributes: {
              custom_source: 'Horror Stories landing page (' + kind + ')',
              // Email only. Klaviyo rejects a 'subscriptions' field here; adding to the list is the consent.
              profile: profile({ email: email })
            },
            relationships: { list: { data: { type: 'list', id: listId } } }
          });
        };

        if (button) button.disabled = true;
        send('events', {
          type: 'event',
          attributes: {
            properties: props,
            metric: { data: { type: 'metric', attributes: { name: eventName } } },
            profile: profile(attrs)
          }
        }).then(subscribe).then(done).catch(function () {
          form.classList.add('is-error');
          msg.textContent = 'Sorry, something went wrong. Please try again.';
        }).then(function () {
          if (button) button.disabled = false;
        });
      });
    });
  });
})();
